import Vue from 'vue';
import vuetify from './plugins/vuetify';

import router from './router';

import axios from 'axios';
import VueAxios from 'vue-axios';
import VueI18n from 'vue-i18n';
import Languages from './languages/languages.js';
import ModalBus from './plugins/modalBus.js';
import storePlugin from './plugins/store.js';
import Settings from './plugins/settings.js';
import API from './plugins/api.js';
import Helpers from './plugins/helpers.js';
import App from './App.vue';

import '@fortawesome/fontawesome-free/css/all.css';

import 'tinymce/tinymce';
import 'tinymce/themes/silver/theme';
import 'tinymce/plugins/paste';
import 'tinymce/plugins/link';
import 'tinymce/plugins/table';
import 'tinymce/plugins/lists';
import 'tinymce/plugins/code';
import 'tinymce/plugins/image';

import 'tinymce/skins/ui/oxide/content.inline.min.css';
import 'tinymce/skins/ui/oxide/content.min.css';
import 'tinymce/skins/ui/oxide/content.mobile.min.css';
import 'tinymce/skins/ui/oxide/skin.min.css';
import 'tinymce/skins/ui/oxide/skin.mobile.min.css';
import 'tinymce/skins/ui/oxide/fonts/tinymce-mobile.woff';

import VCurrencyField from 'v-currency-field';
Vue.use(VCurrencyField);

import VuejsClipper from 'vuejs-clipper';

Vue.use(VuejsClipper);

import VueGoogleCharts from 'vue-google-charts';

Vue.use(VueGoogleCharts);

Vue.use(VueAxios, axios);

Vue.use(VueI18n);
const i18n = new VueI18n({
    locale: 'hr',
    messages: Languages.translations,
});

import Storage from 'vue-ls';

Vue.use(Storage, {
    namespace: 'ide3app__', // key prefix
    name: 'ls', // name variable Vue.[ls] or this.[$ls],
    storage: 'local', // storage name session, local, memory
});

import CrossTabBus from './plugins/crossTabBus.js';

Vue.use(CrossTabBus);

Vue.use(ModalBus);

Vue.use(storePlugin);

Vue.use(Settings);

Vue.use(API);

Vue.use(Helpers);

Vue.config.productionTip = false;

const app = new Vue({
    vuetify,
    i18n,
    router: router,
    render: (h) => h(App),
}).$mount('#app');

router.afterEach(() => {
    app.$APICall('get', 'version', {}, (data, success) => {
        if (success) {
            if (data.version != app.$getCookie('ide3_version')) {
                app.$setCookie('ide3_version', data.version, 30);
                window.location.reload(true);
            }
        }
    });
});
